// extracted by mini-css-extract-plugin
export default {"TopSection":"TitleBar_TopSection__jkw+y","subTitle":"TitleBar_subTitle__aPP7E","spanText":"TitleBar_spanText__++P1B","Title":"TitleBar_Title__My+V3"};